module.exports = __webpack_public_path__ + "static/media/AvenirNext-DemiBoldItalic.eccfb4f8.woff";